import PropTypes from 'prop-types';
import React from 'react';

import { ApiProvider, EventType } from './components/ApiClientsContext';
import { ErrorProvider } from './components/ErrorContext';
import { LocationProvider } from './components/LocationContext';
import { MemberProvider } from './components/MemberContext';
import { TrackingProvider } from './components/TrackingContext';
import { EventModalProps, RightRailForm } from './LegacyModal/RightRailForm';

export const EventModal: React.FC<EventModalProps> = props => {
  return (
    <ErrorProvider>
      <ApiProvider>
        <MemberProvider>
          <LocationProvider>
            <TrackingProvider>
              <RightRailForm {...props} />
            </TrackingProvider>
          </LocationProvider>
        </MemberProvider>
      </ApiProvider>
    </ErrorProvider>
  );
};

EventModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
  weddingId: PropTypes.string.isRequired,
  type: PropTypes.oneOf<EventType>(['Ceremony', 'WeddingEvent']).isRequired,
  event: PropTypes.oneOfType([PropTypes.array]),
  hasWWS: PropTypes.bool.isRequired,
  hideDate: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  onHideDate: PropTypes.func.isRequired,
};

EventModal.defaultProps = {
  event: null,
  hideDate: false,
};
